import style from './styles.module.scss';

const Particules = ({ children }) => {
    return (<div className={style.content}>
        {children}
    </div>
    )
}

export default Particules;